import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'csvTags' })
export class CsvTagsPipe implements PipeTransform {
  public transform(items: any): any {
    return typeof items === 'object' ? items.map(item => ' ' + item.value) : items;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/csvTags.pipe.ts